import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Send, X } from "lucide-react";

export function FollowupDialog({ contract, preview, sending, onCancel, onSend }) {
  return (
    <Dialog open={!!contract} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="sm:max-w-2xl" data-testid="followup-preview-modal">
        <DialogHeader>
          <DialogTitle>Send follow-up to {contract?.contact_name || contract?.contact_email}</DialogTitle>
          <p className="text-xs text-slate-500">This email will be sent from the shared sender with Reply-To routed to the AM.</p>
        </DialogHeader>
        {!preview ? (
          <div className="py-8 flex items-center justify-center text-sm text-slate-500">Rendering preview…</div>
        ) : (
          <div className="space-y-3">
            <div className="grid grid-cols-[80px_1fr] gap-2 text-xs">
              <span className="text-slate-500 font-medium">To</span><span className="text-slate-900 font-mono">{preview.to}</span>
              <span className="text-slate-500 font-medium">Reply-To</span><span className="text-slate-900 font-mono">{preview.reply_to || "(sender)"}</span>
              <span className="text-slate-500 font-medium">Subject</span><span className="text-slate-900 font-semibold">{preview.subject}</span>
            </div>
            <div className="border border-slate-200 rounded-md bg-slate-50 p-4 text-sm text-slate-800 whitespace-pre-wrap font-mono max-h-72 overflow-auto" data-testid="followup-preview-body">
              {preview.body_md}
            </div>
            <p className="text-[11px] text-slate-400">Body preview is markdown. Recipient sees an HTML render with **bold** applied.</p>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="followup-preview-cancel">
            <X className="h-4 w-4 mr-1" />
            Cancel
          </Button>
          <Button onClick={onSend} disabled={!preview || sending} className="bg-[#007BFF] hover:bg-[#0069d9] text-white" data-testid="followup-preview-send">
            <Send className="h-4 w-4 mr-1" />
            {sending ? "Sending…" : "Send now"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
